module.exports = __webpack_public_path__ + "static/media/Press-Layout_02.bed5d045.jpg";